import React from 'react';
import { ContentfulImage, Grid, ImageAspectBox1x1, TWO_COLUMN_MAX_WIDTH, } from '../../ui';
import styled, { css } from 'styled-components';
import { createBasicColorSet, cssColorSet, spacer24, spacer32, spacer40, spacer48, } from '@spotify-internal/encore-web';
const HeroModuleBox = styled(Grid) `
  ${({ colors }) => (colors === null || colors === void 0 ? void 0 : colors.backgroundColor)
    ? cssColorSet(createBasicColorSet(colors.backgroundColor, colors.textColor))
    : ''}
  padding-top: ${spacer40};
  padding-bottom: ${spacer40};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${spacer24};
    padding-bottom: ${spacer48};
  }
`;
const ImageContainer = styled(ImageAspectBox1x1) `
  width: 100%;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    margin-bottom: ${spacer24};
  }
`;
const ImageBox = styled.div `
  grid-column: ${({ layout }) => layout === 'imageLeft' ? '1 / span 4' : '9 / span 4'};
  order: ${({ layout }) => (layout === 'imageLeft' ? '1' : '2')};
  align-self: center;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 1;
  }
`;
const noImageTextBoxStyles = css `
  grid-column: 3 / span 8;
  @media (max-width: 1080px) {
    grid-column: 1 / -1;
  }

  padding-top: 88px;
  padding-bottom: 88px;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${spacer32};
    padding-bottom: ${spacer24};
  }
`;
const TextBox = styled.div `
  display: flex;
  justify-content: flex-start;
  grid-column: ${({ layout }) => layout === 'imageLeft' ? '6 / span 6' : '1 / span 6'};
  order: ${({ layout }) => (layout === 'imageLeft' ? '2' : '1')};

  @media (max-width: 1080px) {
    grid-column: ${({ layout }) => layout === 'imageLeft' ? '6 / span 7' : '1 / span 7'};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 2;
  }

  ${({ noImage }) => (noImage ? noImageTextBoxStyles : '')}
`;
const centeredInnerTextStyles = css `
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  text-align: center;
`;
const InnerText = styled.div `
  height: auto;
  align-self: center;

  ${({ noImage }) => (noImage ? centeredInnerTextStyles : '')}
`;
export const HeroLayout = React.forwardRef(({ children, image, layout = 'imageLeft', colors, className }, ref) => {
    return (React.createElement(HeroModuleBox, { colors: colors, className: className },
        image && (React.createElement(ImageBox, { layout: layout },
            React.createElement(ImageContainer, null,
                React.createElement(ContentfulImage, { asset: image })))),
        React.createElement(TextBox, { layout: layout, noImage: !image },
            React.createElement(InnerText, { noImage: !image, ref: ref }, children))));
});
//# sourceMappingURL=HeroLayout.js.map